import React, { useEffect, useState,useRef } from "react";
import {
  InputGroup,
  Form,
  ButtonGroup,
  Button,
  Table,
  Dropdown,
  Row,
  Modal,
  Col,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ExportApi from "../api/ExportApi";
import Pagination from "@mui/material/Pagination";
import ReactPaginate from "react-paginate";
import Stack from "@mui/material/Stack";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { ORDER_STATUS_COLOR } from "../helper/constant";
import loader from "../images/loader/loaderrrr.gif"

export default function OrderTable() {
  const [products, setproducts] = useState([]);
  const [products1, setproducts1] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [smShow, setSmShow] = useState(false);
  const [smShow1, setSmShow1] = useState(false);
  const [tabnameTaxt, setTabnameTaxt] = useState(null);
  const [currentSortKey, setCurrentSortKey] = useState(null);
  const [FilterOnCModal, setFilterOnCModal] = useState();
  const [filterTabNames, setFilterTabNames] = useState([]);
  const [text, setText] = useState();
  const [isLoading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [ActiveIndex, setActiveIndex] = useState(0);
  // const [FilterHedertext, setFilterHedertext] = useState([]);
  const [FilterHedertext, setFilterHedertext] = useState();
  const [currentSortOrder, setCurrentSortOrder] = useState(1);
  const [totalPageNumber, setTotalPageNumber] = useState();
  const [returnCount, setReturnCount] = useState();
  const [recentlyCount, setRecentlyCount] = useState();
  const [shippedOutCount, setShippedOutCount] = useState();
  const [readyCount, setReadyCount] = useState();
  const [readyTestCount, setReadyTestCount] = useState();
  const [shippedCount, setShippedCount] = useState();
  const [waitCount, setWaitCount] = useState();
  const [filterColumnName, setFilterColumnName] = useState();
  const [filterTabData, setFilterTabData] = useState();
  const [tabName, setTabName] = useState();
  const [tagName, setTagName] = useState();
  const [singleTabName, setSingleTabName] = useState();
  const [filterName, setFilterName] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [waitingSellerStatus, setWaitingSellerStatus] = useState(false);
  const [shippingSellerStatus, setShippingSellerStatus] = useState(false);
  const [readyTestStatus, setReadTestStatus] = useState(false);
  const [readyShipmentStatus, setReadyShipmentStatus] = useState(false);
  const [shippedOutStatus, setShippedOutStatus] = useState(false);
  const [recentlyDeliveredStatus, setRecentlyDeliveredStatus] = useState(false);
  const [returnStatus, setReturnStatus] = useState(false);
  const [problemOrderStatus, setProblemOrderStatus] = useState(false);
  const [allnames, setAllNames] = useState();
  const [currenttab, setCurrentTab] = useState();
  const [ordersids, setOrdersIds] = useState();
  const intervalRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [filterData, setFilterData] = useState();
  const [pageOffset, setPageOffset] = useState(0);
  const [filtersearch, setFilterSearch] = useState();
  const [intervalTime, setIntervalTime] = useState(60000);
  const [filterstatus, setfilterstatus] = useState();
  const [paginationConfig, setPaginationConfig] = useState({
    pageRangeDisplayed: 5,
    marginPagesDisplayed: 2,
  });
  const [tableLoader , setTableLoader] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 576) {
        setPaginationConfig({
          pageRangeDisplayed: 2,
          marginPagesDisplayed: 1,
        });
      } else {
        setPaginationConfig({
          pageRangeDisplayed: 5,
          marginPagesDisplayed: 2,
        });
      }
    };
  
    window.addEventListener("resize", handleResize);
    handleResize(); // run on initial load
  
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [ShowCol, setShowCol] = useState({
    order: true,
    Customer: true,
    productname: true,
    paymentStatus: true,
    fulfilment_status: true,
    date: true,
    Delivery_Method: true,
    tag: true,
  });
 
  // Function to create a new tab and handle the API request.
  const handleNewTab = () => {
 
    ExportApi.createFilterTabName(
      tabnameTaxt,
      FilterOnCModal,
      filterTabData,
      "Order"
    )
      .then((resp) => {
        if (resp.data.message == "Data Created successfully") {
          toast.success("Data created successfully");
          setSmShow1(false);
          handleGetAllFilterTabNames();
          setFilterTabNames([]);
          setFilterTabData();
          setFilterOnCModal();
          setTabnameTaxt();
        } else {
          toast.error(resp.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
 
  const [productChecked, setProductChecked] = useState(
    products?.map(() => false)
  );
  let navigate = useNavigate();

  const handleSelectAll = (event) => {
    let result = event.target.checked;
    if (result) {
      let data = products1.map((item) => {
        return { ...item, isSelected: true };
      });
      setproducts1([...data]);
    } else {
      let data = products1.map((item) => {
        return { ...item, isSelected: false };
      });
      setproducts1([...data]);
    }
  };

  const sortHere = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = products1.sort((a, b) => {
      if (a[key] < b[key]) return -1 * sortOrder;
      if (a[key] > b[key]) return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  const sortByName = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = products1.sort((a, b) => {
      if (a.buyerId.firstname < b.buyerId.firstname) return -1 * sortOrder;
      if (a.buyerId.firstname > b.buyerId.firstname) return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };


  const sortByProduct = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = products1.sort((a, b) => {
      if (a.productId.productname < b.productId.productname)
        return -1 * sortOrder;
      if (a.productId.productname > b.productId.productname) return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };


  const sortByPaymentStatus = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = products1.sort((a, b) => {
      if (a.payment_details.status < b.payment_details.status)
        return -1 * sortOrder;
      if (a.payment_details.status > b.payment_details.status) return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  //sorting function for the order status
  //key used for the order Status filter
  const sortByStatus = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = products1.sort((a, b) => {
      if (
        a.deliveryStatusId.deliveryStatus.status <
        b.deliveryStatusId.deliveryStatus.status
      )
        return -1 * sortOrder;
      if (
        a.deliveryStatusId.deliveryStatus.status >
        b.deliveryStatusId.deliveryStatus.status
      )
        return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  const handlePageNumber = (e) => {
    // console.log(e.selected ,"hitpagenumber")
    // setPageNumber(e.target.innerText);
    setPageNumber(e.selected + 1);
  };

  useEffect(() => {
    if (ActiveIndex == 0) {
      // console.log("hit new one")
    //  handleOrderPagination(pageNumber);
     handleOrderFilternew(filterData, pageNumber)
    
    }
  }, [ActiveIndex, pageNumber]);

  const HandleSearchData = (data) => {
    let Data = products.filter(
      (val) =>
        val?.productId?.productname
          ?.toLowerCase()
          .includes(data.toLowerCase()) || // Check if product name includes the search data
        val?.buyerId?.firstname?.toLowerCase().includes(data.toLowerCase()) || // Check if buyer's first name includes the search data
        String(val?.orderId).toLowerCase().includes(data.toLowerCase()) || // Check if ID includes the search data
        val?.payment_details?.status
          .toLowerCase()
          .includes(data.toLowerCase()) || // Check if payment status includes the search data
        val?.deliveryStatusId?.deliveryStatus?.status
          .toLowerCase()
          .includes(data.toLowerCase())
    );
    setproducts1([...Data]);
  };

 
  
 
  // Function to handle pagination of orders based on the selected page.

  const handleOrderPagination = (page) => {
    setShowLoader(true);
    ExportApi.getOrderPaginationData(page)
      .then((resp) => {
        let data = resp?.data?.data;
        setAllNames(resp?.data?.additionalInfo?.uniquenames)
        setproducts1(data); 
        setproducts(data);
        setTotalPageNumber(resp?.data?.additionalInfo?.totalPage); 
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setShowLoader(false);
      });
  };

    useEffect(() => {
    handleOrderPagination();
  }, [ ])
  const handleOrderPaginationnew = (page) => {

    ExportApi.getOrderPaginationData(page)
      .then((resp) => {
        let data = resp?.data?.data;
        let filteredOrders = data.filter(item => 
          item.deliveryStatusId?.deliveryStatus?.status === "Shipped From Seller"
        );

        // Extract orderIds from filtered orders
        let orderIds = filteredOrders.map(order => order?.orderId);
        setOrdersIds(orderIds);
    
     
        setAllNames(resp?.data?.additionalInfo?.uniquenames)
        setproducts1(data); 
        setproducts(data);
        setTotalPageNumber(resp?.data?.additionalInfo?.totalPage); 
      })
      .catch((err) => {
        console.log(err);
      });
  };
 
  
  
  useEffect(() => {
    // Check if shippedOutStatus is true
    if (shippedOutStatus  ||
      recentlyDeliveredStatus ||
      returnStatus ||
      problemOrderStatus ||
      readyTestStatus ||
      readyShipmentStatus ||
      waitingSellerStatus ||
      shippingSellerStatus) {
      return;
    }
        // console.log("hit 1 console");
    //handleOrderPaginationnew(pageNumber);
    if (filterstatus == false){
      console.log(filterstatus,"filterstatus>>>321");
      const intervalId = setInterval(() => {
        handleOrderPaginationnew(pageNumber); 
        console.log(intervalTime,"hit a >>>>>>>>>>>>>>>>");
      }, intervalTime);
  
      return () => clearInterval(intervalId);
    }
     
  }, [pageNumber, shippedOutStatus,recentlyDeliveredStatus,
    returnStatus,
    problemOrderStatus,
    intervalTime,
    readyTestStatus,
    readyShipmentStatus,
    waitingSellerStatus,
    shippingSellerStatus,]);
  
  const updatetrackingStatus = (ordersids) => {
    const data = {
      orderid: ordersids,
      trackstatus: "DELIVERED",
    };
    ExportApi.updatetracking(data)
      .then((resp) => {
      
        const mydata = resp
      })
      .catch((err) => {
        console.error("Error in trackingAllStatus:", err);
      });
  };

  // Function to update tracking status for the current orderId
  const updateCurrentOrderStatus = () => {
    if (ordersids?.length > 0) {
      const currentOrderId = ordersids[currentIndex];
      updatetrackingStatus(currentOrderId);
      
      // Move to the next orderId
      const nextIndex = (currentIndex + 1) % ordersids?.length;
      setCurrentIndex(nextIndex);
    }
  };

  useEffect(() => {
    if (shippedOutStatus ||
      recentlyDeliveredStatus ||
      returnStatus ||
      problemOrderStatus ||
      readyTestStatus ||
      readyShipmentStatus ||
      waitingSellerStatus ||
      shippingSellerStatus) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      return;
    }
    // console.log("hit 2 console");
    if (ordersids?.length > 0) {
      intervalRef.current = setInterval(updateCurrentOrderStatus, 10000);
      console.log("hit b >>>>>>>>>>>>>>>>");
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [ordersids, shippedOutStatus, 
    recentlyDeliveredStatus,
    returnStatus,
    problemOrderStatus,
    readyTestStatus,
    readyShipmentStatus,
    waitingSellerStatus,
    shippingSellerStatus,]);
  
  const handleOrderFilter = (data) => {
    setTableLoader(true)
    setWaitingSellerStatus(!waitingSellerStatus);
    setPageNumber(1);
     setPageOffset(0);
    setShippingSellerStatus(false);
    setRecentlyDeliveredStatus(false);
    setReadTestStatus(false);
    setReadyShipmentStatus(false);
    setReturnStatus(false);
    setShippedOutStatus(false);
    setProblemOrderStatus(false);
    setFilterData(data);
    if (waitingSellerStatus) {
      handleOrderPagination(1);
    } else {
      ExportApi.orderFilter(data, pageNumber)
        .then((resp) => {
          let data = resp.data.data;
          console.log("data>>>>4");
          setproducts1(data);
          setproducts(data);
          setTotalPageNumber(resp.data.totalPage);
          setLoading(false);
              setTableLoader(false)

     
        })
        .catch((err) => {
          console.log(err);
              setTableLoader(false)

        });
    }
  };
  const handleOrderShippingFilter = (data) => {
    setTableLoader(true)
    setShippingSellerStatus(!shippingSellerStatus);
    setPageNumber(1);
     setPageOffset(0);
    setWaitingSellerStatus(false);
    setReturnStatus(false);
    setRecentlyDeliveredStatus(false);
    setReadTestStatus(false);
    setReadyShipmentStatus(false);
    setShippedOutStatus(false);
    setProblemOrderStatus(false);
    setFilterData(data);
    if (shippingSellerStatus) {
      handleOrderPagination(1);
    } else {
      ExportApi.orderFilter(data, pageNumber)
        .then((resp) => {
          let data = resp.data.data;
          console.log("data>>>>5");
          setproducts1(data);
          setproducts(data);
          setTotalPageNumber(resp.data.totalPage);
          setLoading(false);
              setTableLoader(false)

      
        })
        .catch((err) => {
          console.log(err);
              setTableLoader(false)

        });
    }
  };
  const handleOrderTestFilter = (data) => {
    setTableLoader(true)
    setReadTestStatus(!readyTestStatus);
   
    setShippingSellerStatus(false);
    setRecentlyDeliveredStatus(false);
    setReturnStatus(false);
    setWaitingSellerStatus(false);
    setReadyShipmentStatus(false);
    setShippedOutStatus(false);
    setProblemOrderStatus(false);
    setFilterData(data);

    setPageNumber(1);
    setPageOffset(0);  
    // console.log(pageOffset,"offset>>>>>");
    if (readyTestStatus) {
      handleOrderPagination(1);
    } else {
      ExportApi.orderFilter(data,  1)
        .then((resp) => {
          // console.log(resp,"resp>>33");
          // console.log(pageOffset,"pageOffset>>>>44");
           
          let data = resp.data.data;
          console.log("data>>>>6");
          setproducts1(data);
          setproducts(data);
          setTotalPageNumber(resp.data.totalPage);
          setLoading(false);
              setTableLoader(false)

          
        })
        .catch((err) => {
          console.log(err);
              setTableLoader(false)

        });
    }
  };
  // useEffect(() => {
  //   // Ensure forcePage is updated correctly when pageOffset changes
  //   console.log('Page offset has changed:', pageOffset);
  // }, [pageOffset]);

  const handleOrderShipmentFilter = (data) => {
    setTableLoader(true)
    setReadyShipmentStatus(!readyShipmentStatus);
    setPageNumber(1);
     setPageOffset(0);
    setShippedOutStatus(false);
    setReturnStatus(false);
    setRecentlyDeliveredStatus(false);
    setReadTestStatus(false);
    setShippingSellerStatus(false);
    setWaitingSellerStatus(false);
    setProblemOrderStatus(false);
    setFilterData(data);
    if (readyShipmentStatus) {
      handleOrderPagination(1);
    } else {
      ExportApi.orderFilter(data, pageNumber)
        .then((resp) => {
          let data = resp.data.data;
          console.log("data>>>>7");
          setproducts1(data); 
          setproducts(data);
          setTotalPageNumber(resp.data.totalPage);
          setLoading(false);
              setTableLoader(false)

          
        })
        .catch((err) => {
          console.log(err);
              setTableLoader(false)

        });
    }
  };
  const handleOrderShippedFilter = (data) => {
    setTableLoader(true)
    setShippedOutStatus(!shippedOutStatus);
    setPageNumber(1);
     setPageOffset(0);
    setRecentlyDeliveredStatus(false);
    setReturnStatus(false);
    setReadyShipmentStatus(false);
    setReadTestStatus(false);
    setShippingSellerStatus(false);
    setWaitingSellerStatus(false);
    setProblemOrderStatus(false);
    setFilterData(data);
    if (shippedOutStatus ) {
      handleOrderPagination(1);
    } else {
      ExportApi.orderFilter(data, pageNumber)
        .then((resp) => {
          let data = resp.data.data;
          setproducts1(data);
          setproducts(data);
          setTotalPageNumber(resp.data.totalPage);
          setLoading(false);
              setTableLoader(false)

          
        })
        .catch((err) => {
          console.log(err);
              setTableLoader(false)

        });
    }
  };

  const handleOrderRecentlyFilter = (data) => {
    setTableLoader(true)
    setRecentlyDeliveredStatus(!recentlyDeliveredStatus);
    setPageNumber(1);
     setPageOffset(0);
    setReturnStatus(false);
    setShippedOutStatus(false);
    setReadyShipmentStatus(false);
    setReadTestStatus(false);
    setShippingSellerStatus(false);
    setWaitingSellerStatus(false);
    setProblemOrderStatus(false);
    setFilterData(data);

    if (recentlyDeliveredStatus) {
      handleOrderPagination(1);
    } else {
      ExportApi.orderFilter(data, pageNumber)
        .then((resp) => {
          let data = resp.data.data;
          console.log(data,"data>>>>9");
          setproducts1(data); 
          setproducts(data); 
          setTotalPageNumber(resp.data.totalPage);
          setLoading(false);
              setTableLoader(false)

          
        })
        .catch((err) => {
          console.log(err);
              setTableLoader(false)

        });
    }
  };

  const handleOrderReturnFilter = (data) => {
    setTableLoader(true)
    setReturnStatus(!returnStatus);
    setPageNumber(1);
     setPageOffset(0);
    setRecentlyDeliveredStatus(false);
    setShippedOutStatus(false);
    setReadyShipmentStatus(false);
    setReadTestStatus(false);
    setShippingSellerStatus(false);
    setWaitingSellerStatus(false);
    setProblemOrderStatus(false);
    setFilterData(data);
    if (returnStatus) {
      handleOrderPagination(1);
    } else {
      ExportApi.orderFilter(data, pageNumber)
        .then((resp) => {
          let data = resp.data.data;
          console.log(data,"data>>>>10");
          setproducts1(data); 
          setproducts(data);
          setTotalPageNumber(resp.data.totalPage);
          setLoading(false);
              setTableLoader(false)

          
        })
        .catch((err) => {
          console.log(err);
              setTableLoader(false)

        });
    }
  };

  const handleProblemOrderFilter = (data) => {
    setTableLoader(true)
    setProblemOrderStatus(!problemOrderStatus);
    setPageNumber(1);
     setPageOffset(0);
    setReturnStatus(false);
    setRecentlyDeliveredStatus(false);
    setShippedOutStatus(false);
    setReadyShipmentStatus(false);
    setReadTestStatus(false);
    setShippingSellerStatus(false);
    setWaitingSellerStatus(false);
    setFilterData(data);
    if (problemOrderStatus) {
      handleOrderPagination(1);
    } else {
      ExportApi.orderFilter(data, pageNumber)
        .then((resp) => {
          let data = resp.data.data;
          console.log(data,"data>>>>11");
          setproducts1(data); 
          setproducts(data); 
          setTotalPageNumber(resp.data.totalPage); 
          setLoading(false);
              setTableLoader(false)

    
        })
        .catch((err) => {
          console.log(err);
              setTableLoader(false)

        });
    }
  };

  const handleOrderFilternew = (filterData, pageNo) => {
    setTableLoader(true)
    setLoading(true);

    ExportApi.orderFilter(filterData, pageNo)
      .then((response) => {
        setTableLoader(false)
        const fetchedData = response.data.data;
        console.log("data>>>>12");
        setproducts1(fetchedData);
        setproducts(fetchedData);
        setTotalPageNumber(response.data.totalPage);
        setLoading(false);
            setTableLoader(false)

      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
        setTableLoader(false)
            setTableLoader(false)


      });
  };


  const handleFilterTab = (id, index, name) => {
    setCurrentTab(name);
    setShowLoader(true);
    setActiveIndex(index);
    if (name === "All") {
      console.log("data>>>>13");
      setproducts1(products);
      setShowLoader(false);
    } else {
      ExportApi.getTagName(id)
        .then((resp) => {
          let data = resp.data;
          if (data.message === "Data fetched successfully") {
            setTagName(data.data.filterName);
            console.log("data>>>>14");
            setproducts1(data.data.result);
            // setTabName(data.data.tabname);
            setFilterName(data?.data?.tabName);
            setShowLoader(false);
          } else {
            //toast.error(resp.data.message); // Display an error toast message.
            setTagName(data.data.filterName);
            console.log("data>>>>15");
            setproducts1(data.data.result);
            // setTabName(data.data.tabname);
            setFilterName(data?.data?.tabName);
            setShowLoader(false);
          }
        })
        .catch((err) => {
          console.log(err); 
          setShowLoader(false);
        });
    }
  };

  const handleTableFilter = () => {
    setfilterstatus(true);
    HandleSearchData(filtersearch);
    setIntervalTime(1000000);
    console.log("handleTableFilter>>")
    setFilterHedertext(text);
    setSmShow(false);
    setText();
    
  };

  const handleOrderCount = () => {
    ExportApi.getOrderCount()
      .then((resp) => {
        let data = resp.data.Data;
        setWaitCount(data.Wait);
        setShippedCount(data.Shipped);
        setReadyTestCount(data.ReadyTest);
        setReadyCount(data.Ready);
        setShippedOutCount(data.ShippedOut);
        setRecentlyCount(data.Recently);
        setReturnCount(data.Return);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [showAll, setShowAll] = useState(0);
  const handleGetAllFilterTabNames = () => {
    ExportApi.getAllTabName("Order")
      .then((resp) => {
        if (resp.data.message === "Data fetched Successfully") {
          let data = resp.data.data;
          let result = data?.filter((item) => item?.tabName != "All");
          if (result.length > 0) setShowAll(result.length);
          setTabName(data);
          setSingleTabName(data[0]?.filterName);
        } else {
          toast.error(resp.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClearFilter = (name, filter, data) => {
    if (data == "clearallfilters") {
      setActiveIndex(0);
      return;
    }
    ExportApi.removeFilter(name, filter)
      .then((resp) => {
        let data = resp.data;
        if (data.message === "Data removed successfully") {
          toast.success(resp.data.message);
          handleOrderCount();
          handleGetAllFilterTabNames();
          setActiveIndex(0);
        } else {
          toast.error(resp.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCheck = (data, id) => {
    let product_id = id;
    if (data) {
   
      for (let i = 0; i < products1.length; i++) {
        const element1 = products1[i];
        if (element1?._id.includes(product_id)) {
          products1[i].isSelected = true;
        }
      }
    } else {
      for (let i = 0; i < products1.length; i++) {
        const element1 = products1[i];
        if (element1?._id.includes(product_id)) {
          products1[i].isSelected = false;
        }
      }
    }
    console.log("data>>>>16");
    setproducts1([...products1]);
  };

  const changeAddFilter = (name) => {
    let filter_name = name;
    setFilterOnCModal("");
    setFilterTabData("");
    setTimeout(() => {
      setFilterOnCModal(filter_name);
    }, 1000);
  };
 
 
  useEffect(() => {
    handleOrderCount(); 
    handleGetAllFilterTabNames(); 
  }, []);

  useEffect(() => {
    setFilterTabNames(JSON.parse(localStorage.getItem("filterTab")));
  }, [localStorage.getItem("filterTab")]);
  
  console.log(filterTabData,"filterTabData>>>>");
  return (
    <div>
      <ToastContainer />

      <div className="order_stats_card d-lg-flex gap-2 justify-content-between mt-5 product_status">
        <div className="bg-lightgrey text-dark text-center border p-2 rounded-4">
          <h5 className="text-dark fw-bold">Incoming</h5>
          <div className="d-sm-flex gap-2 justify-content-between product_status_parent_button">
            <div className="tb-card rounded mb-2 mb-lg-0">
              <Button
                className={`border w-100 text-dark bg-grey text-center ${
                  waitingSellerStatus == true
                    ? "activeOrderButton bg-dark text-white"
                    : ""
                }`}
                onClick={() => handleOrderFilter("Waiting on Seller")}
              >
                Waiting for <br />
                Seller
              </Button>
              {waitCount > 0 ? (
                <span className="numbering">{waitCount}</span>
              ) : (
                ""
              )}
            </div>
            <div className="tb-card rounded mb-2 mb-lg-0">
              <Button
                className={`border w-100 text-dark bg-grey text-center ${
                  shippingSellerStatus == true
                    ? "activeOrderButton bg-dark text-white"
                    : ""
                }`}
                setFilterTabData
                onClick={() => handleOrderShippingFilter("Shipped From Seller")}
              >
                Shipping for <br />
                Seller
              </Button>
              {shippedCount > 0 ? (
                <span className="numbering">{shippedCount}</span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="bg-lightgrey text-dark text-center border p-2 rounded-4 mt-2 mt-sm-0">
          <h5 className="text-dark fw-bold">Processing</h5>
          <div className="d-sm-flex gap-2 justify-content-between product_status_parent_button">
            <div className="tb-card rounded mb-2 mb-lg-0">
              <Button
                className={`border w-100 text-dark bg-grey text-center ${
                  readyTestStatus == true
                    ? "activeOrderButton bg-dark text-white"
                    : ""
                }`}
                onClick={() => handleOrderTestFilter("Ready For Test")}
              >
                Ready for <br />
                Test
              </Button>
              {readyTestCount > 0 ? (
                <span className="numbering_ready">{readyTestCount}</span>
              ) : (
                ""
              )}
            </div>
            <div className="tb-card rounded mb-2 mb-lg-0">
              <Button
                className={`border w-100 text-dark bg-grey text-center ${
                  readyShipmentStatus == true
                    ? "activeOrderButton bg-dark text-white"
                    : ""
                }`}
                onClick={() => handleOrderShipmentFilter("Ready For Shipment")}
              >
                Ready for <br />
                Shipment
              </Button>
              {readyCount > 0 ? (
                <span className="numbering_shipment">{readyCount}</span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="bg-lightgrey text-dark text-center border p-2 rounded-4 mt-2 mt-sm-0">
          <h5 className="text-dark fw-bold">Outgoing</h5>
          <div className="d-sm-flex gap-2 justify-content-between product_status_parent_button">
            <div className="tb-card rounded mb-2 mb-lg-0">
              <Button
                className={`border w-100 text-dark bg-grey text-center ${
                  shippedOutStatus == true
                    ? "activeOrderButton bg-dark text-white"
                    : ""
                }`}
                onClick={() => handleOrderShippedFilter("Shipped Out")}
              >
                Shipped Out
              </Button>
              {shippedOutCount > 0 ? (
                <span className="numbering_out">{shippedOutCount}</span>
              ) : (
                ""
              )}
            </div>
            <div className="tb-card rounded mb-2 mb-lg-0">
              <Button
                className={`border w-100 text-dark bg-grey text-center ${
                  recentlyDeliveredStatus == true
                    ? "activeOrderButton bg-dark text-white"
                    : ""
                }`}
                onClick={() => handleOrderRecentlyFilter("Recently Delivered")}
              >
                Recently Delivered
              </Button>
              {recentlyCount > 0 ? (
                <span className="numbering">{recentlyCount}</span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="bg-lightgrey text-dark text-center border p-2 rounded-4 mt-2 mt-sm-0">
          <h5 className="text-dark fw-bold">Other</h5>
          <div className="d-sm-flex gap-2 justify-content-between product_status_parent_button">
            <div className="tb-card rounded mb-2 mb-lg-0">
              <Button
                className={`border w-100 text-dark bg-grey text-center ${
                  returnStatus == true
                    ? "activeOrderButton bg-dark text-white"
                    : ""
                }`}
                onClick={() => handleOrderReturnFilter("Return", 4)}
              >
                Return
              </Button>
              {returnCount > 0 ? (
                <span className="numbering_return">{returnCount}</span>
              ) : (
                ""
              )}
            </div>
            <div className="tb-card rounded mb-2 mb-lg-0">
              <Button
                className={`border w-100 text-dark bg-grey text-center ${
                  problemOrderStatus == true
                    ? "activeOrderButton bg-dark text-white"
                    : ""
                }`}
                onClick={() => handleProblemOrderFilter("Problem Orders")}
              >
                Problem Orders
              </Button>
              {/* <span className="numbering">0</span> */}
            </div>
          </div>
        </div>
      </div>
      <Row>
        {tabName?.map((val, i) => {
          return showAll == 0 ? (
            val?.tabName != "All" ? (
              <h4
                key={i}
                className={i == ActiveIndex ? "activeOne" : ""}
                style={{
                  display: "flex",
                  width: "fit-content",
                  padding: "5px 15px",
                  margin: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleFilterTab(val?._id, i, val?.tabName)}
              >
                {val?.tabName}
              </h4>
            ) : (
              <></>
            )
          ) : (
            <h4
              key={i}
              className={i == ActiveIndex ? "activeOne" : ""}
              style={{
                display: "flex",
                width: "fit-content",
                padding: "5px 15px",
                margin: "10px",
                cursor: "pointer",
              }}
              onClick={() => handleFilterTab(val?._id, i, val?.tabName)}
            >
              {val?.tabName}
            </h4>
          );
        })}
        <hr />
      </Row>
      <div className="d-sm-flex mt-5">
        {/* Start Search Filter */}
        <InputGroup className=" mb-2 mb-sm-0">
          <InputGroup.Text id="basic-addon1" className="bg-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
          </InputGroup.Text>
          <Form.Control
            onChange={(e) => HandleSearchData(e.target.value)}
            placeholder="Filter orders"
            aria-describedby="basic-addon1"
          />
        </InputGroup>
        {/* end Search Filter */}
        <ButtonGroup
          aria-label="Basic example"
          className="border ms-sm-2 mb-2 mb-sm-0"
        >
          {/* Start Filter Orders */}
          <Button
            variant="light"
            className="d-flex align-items-center"
            onClick={() => setSmShow(true)}
          >
            <span className="me-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-filter"
                viewBox="0 0 16 16"
              >
                <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />
              </svg>
            </span>
            Filter
          </Button>
          <Button
            variant="light"
            className="d-flex align-items-center"
            onClick={() => handleOrderPaginationnew(0)}
          >
           
            Clear Filter
          </Button>
          {/* end Filter Orders  */}

          {/* Start Add Dynamic Column in the table */}
          <Dropdown
            variant="light"
            className="border d-flex align-items-center"
          >
            <Dropdown.Toggle
              id="dropdown-autoclose-true"
              className="bg-light text-dark border-0"
            >
              <span className="me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-layout-three-columns"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13zM1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5H5V1H1.5zM10 15V1H6v14h4zm1 0h3.5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5H11v14z" />
                </svg>
              </span>
              Columns
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Form.Check
                inline
                label="Order"
                type={"checkbox"}
                checked={ShowCol.order}
                onChange={(e) => {
                  ShowCol.order = e.target.checked;
                  setShowCol({ ...ShowCol });
                }}
              />
              <Form.Check
                inline
                label="Customer"
                type={"checkbox"}
                checked={ShowCol.Customer}
                onChange={(e) => {
                  ShowCol.Customer = e.target.checked;
                  setShowCol({ ...ShowCol });
                }}
              />
              <Form.Check
                inline
                label="Product Name"
                type={"checkbox"}
                checked={ShowCol.productname}
                onChange={(e) => {
                  ShowCol.productname = e.target.checked;
                  setShowCol({ ...ShowCol });
                }}
              />
              <Form.Check
                inline
                label="Payment Status"
                type={"checkbox"}
                checked={ShowCol.paymentStatus}
                onChange={(e) => {
                  ShowCol.paymentStatus = e.target.checked;
                  setShowCol({ ...ShowCol });
                }}
              />
              <Form.Check
                inline
                label="Fulfilment Status"
                type={"checkbox"}
                checked={ShowCol?.fulfilment_status}
                onChange={(e) => {
                  ShowCol.fulfilment_status = e.target.checked;
                  setShowCol({ ...ShowCol });
                }}
              />
              <Form.Check
                inline
                label="Date"
                name="group1"
                type={"checkbox"}
                checked={ShowCol.date}
                onChange={(e) => {
                  ShowCol.date = e.target.checked;
                  setShowCol({ ...ShowCol });
                }}
              />
            </Dropdown.Menu>
          </Dropdown>

          {filterTabData ? (
            <Button
              type="button"
              onClick={() => setSmShow1(true)}
              variant="light"
            >
              Save
            </Button>
          ) : null}
          {/* End Add Dynamic Column in the Table */}

          {/* Start Sort Order Acc. to the asc. or desc. order */}
          <Button
            variant="light"
            className="d-flex align-items-center"
            onClick={() => sortHere("_id")}
          >
            <span className="me-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-down-up"
                viewBox="0 0 16 16"
              >
                <path
                  filerule="evenodd"
                  d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                />
              </svg>
            </span>{" "}
            Sort
          </Button>
        </ButtonGroup>
      </div>
      <div className="d-flex mt-3 justify-content-between align-items-center">
        <div className="d-flex gap-2">
          {ActiveIndex == 0 ? (
            ""
          ) : (
            <div>
              {tabName?.length > 0 ? (
                <Button
                  className="border bg-custom-light text-dark "
                  onClick={() =>
                    handleClearFilter(tagName, filterName, "clearallfilters")
                  }
                >
                  Clear All Filters
                </Button>
              ) : (
                ""
              )}

              <span className="bg-custom-light px-2 py-1 rounded text-dark ms-3 ">
                {tagName == undefined ? singleTabName : tagName}
                <Button
                  className="border-0 bg-none p-0"
                  onClick={() => {
                    setFilterHedertext();
                    console.log("data>>>>17");
                    setproducts1(products);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="#000"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                    onClick={() => {
                      handleClearFilter(tagName, filterName, "single");
                      setShowAll(showAll - 1);
                    }}
                  >
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </Button>
              </span>
            </div>
          )}
        </div>
      </div>

      {showLoader || tableLoader ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <img src={loader} alt="Loading..." style={{ height: "80px" }} />
        </div>
      ) : (
        <div>
          <div className="table-responsive mt-3 mb-3 custom_widht_order">
            {ActiveIndex == 0 ? (
              <Table bordered striped className="align-middle graphic-table">
                <thead>
                  <tr>
                    {ShowCol.order ? (
                      <>
                        <th className="text-center">
                          <Form.Check
                            id="checkbox-all"
                            name="checkbox-all"
                            onChange={(e) => handleSelectAll(event)}
                            className="d-inline"
                            type="checkbox"
                          />
                        </th>
                        <th>
                          <div style={{display:"flex" , alignItems: "center"}}> 
                          Order
                          <svg
                            onClick={() => sortHere("_id")}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-chevron-expand ms-2"
                            viewBox="0 0 16 16"
                          >
                            <path
                              filerule="evenodd"
                              d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                            />
                          </svg>
                          </div>
                        </th>
                      </>
                    ) : null}

                    {ShowCol.date ? (
                      <th>
                        Date
                        <svg
                          onClick={() => sortHere("createdAt")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                      </th>
                    ) : null}
                    {ShowCol.Customer ? (
                      <th>
                             <div style={{display:"flex" , alignItems: "center"}}> 
                        Customer
                        <svg
                          onClick={() => sortByName()}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                        </div>
                      </th>
                    ) : null}
                    {ShowCol.productname ? (
                      <th>
                        Product Name
                        <svg
                          onClick={() => sortByProduct()}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                      </th>
                    ) : null}
                    {ShowCol.paymentStatus ? (
                      <th>
                        <div style={{display:"flex" , alignItems: "center" , width:"150px"}}> 
                        Payment status
                        <svg
                          onClick={() => sortByPaymentStatus()}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                        </div>
                      </th>
                    ) : null}
                    {ShowCol?.fulfilment_status ? (
                      <th>
                        Fulfillment status
                        <svg
                          onClick={() => sortByStatus()}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                      </th>
                    ) : null}
                  </tr>
                  </thead>
                     <tbody>
                          {products1?.length > 0 ? (
                            products1?.map((product, index) => (
                              <tr
                                key={index}
                                className={
                                  JSON.parse(localStorage.getItem("admin"))?.id ==
                                    (product?.buyerId?._id || product?.sellerId?._id)
                                    ? "admin-order"
                                    : ""
                                }
                              >
                                {ShowCol.order ? (
                                  <>
                                    <td className="text-center">
                                      <Form.Check
                                        id={`checkbox-${index}`}
                                        name={`checkbox-${index}`}
                                        checked={product?.isSelected}
                                        onChange={(e) => {
                                          handleCheck(e.target.checked, product?._id);
                                        }}
                                        className="d-inline"
                                        type="checkbox"
                                      />
                                    </td>
                                    <td
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>

                                        navigate("/OrderDetail/" + product.orderId, {
                                          state: { product_orderId: product?._id },
                                        })
                                      }
                                    >
                                      {product?.orderId}
                                    </td>
                                  </>
                                ) : null}
                                {ShowCol.date ? (
                                  <td>{moment(product?.createdAt).format("L")}</td>
                                ) : null}
                                {ShowCol.Customer ? (
                                  <td>{product?.buyerId?.firstname} {product?.buyerId?.lastname}</td>
                                ) : null}
                                {ShowCol.productname ? (
                                  <td>{product?.productId?.productname}</td>
                                ) : null}

                                {ShowCol.paymentStatus ? (
                                  <td>
                                    <span className="bg-custom-light py-1 px-3 rounded-pill">
                                      {product?.payment_details?.status}
                                    </span>
                                  </td>
                                ) : null}
                                {ShowCol?.fulfilment_status ? (
                                  <td>
                                    <Button style={{
                                      backgroundColor: ORDER_STATUS_COLOR[product?.deliveryStatusId?.deliveryStatus
                                        ?.status ?? "#7f00ff"]
                                    }} className="border text-white">
                                      {
                                        product?.deliveryStatusId?.deliveryStatus
                                          ?.status ?? "Ready for test"
                                      }
                                    </Button>
                                    &nbsp;
                                    {product?.deliveryStatusId?.deliveryStatus
                                      ?.status !== "Refunded" &&
                                      ShowCol?.fulfilment_status &&
                                      product?.deliveryStatusId?.deliveryStatusNew
                                        ?.status === "Ready For Return Shipment" && (
                                        <Button className="order_status_return border text-white">
                                          {
                                            product?.deliveryStatusId?.deliveryStatusNew
                                              ?.status
                                          }
                                        </Button>
                                      )}
                                  </td>
                                ) : null}
                              </tr>
                            ))
                          ) : (
                            <span>No Data Found</span>
                          )}
                        </tbody>
               
              </Table>
            ) : (
              <Table bordered striped className="align-middle graphic-table">
                <thead>
                  <tr>
                    {ShowCol.order ? (
                      <>
                        <th className="text-center">
                          <Form.Check
                            id="checkbox-all"
                            name="checkbox-all"
                            checked={selectAll}
                            onChange={(e) => handleSelectAll(event)}
                            className="d-inline"
                            type="checkbox"
                          />
                        </th>
                        <th>
                          Order
                          <svg
                            onClick={() => sortHere("_id")}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-chevron-expand ms-2"
                            viewBox="0 0 16 16"
                          >
                            <path
                              filerule="evenodd"
                              d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                            />
                          </svg>
                        </th>
                      </>
                    ) : null}

                    {ShowCol.date ? (
                      <th>
                        Date
                        <svg
                          onClick={() => sortHere("createdAt")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                      </th>
                    ) : null}
                    {ShowCol.Customer ? (
                      <th>
                        Customer
                        <svg
                          onClick={() => sortHere("firstname")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                      </th>
                    ) : null}
                    {ShowCol.productname ? (
                      <th>
                        Product Name
                        <svg
                          onClick={() => sortHere("productname")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                      </th>
                    ) : null}
                    {ShowCol.paymentStatus ? (
                      <th>
                        Payment status
                        <svg
                          onClick={() => sortHere("paymentStatus")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                      </th>
                    ) : null}
                    {ShowCol?.fulfilment_status ? (
                      <th>
                        Fulfillment status
                        <svg
                          onClick={() => sortHere("delivery_status")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-chevron-expand ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            filerule="evenodd"
                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                          />
                        </svg>
                      </th>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {products1?.length > 0 ? (
                    products1?.map((product, index) => (
                      <tr key={index}>
                        {ShowCol.order ? (
                          <>
                            <td className="text-center">
                              <Form.Check
                                id={`checkbox-${index}`}
                                name={`checkbox-${index}`}
                                checked={product?.isSelected}
                                onChange={() => {
                                  const newProductChecked = [...productChecked];
                                  newProductChecked[index] =
                                    !newProductChecked[index];
                                  setProductChecked(newProductChecked);
                                }}
                                className="d-inline"
                                type="checkbox"
                              />
                            </td>
                            <td
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigate("/OrderDetail/" + product.orderId)
                              }
                            >
                              {product?.orderId}
                            </td>
                          </>
                        ) : null}
                        {ShowCol.date ? (
                          <td>{moment(product?.createdAt).format("L")}</td>
                        ) : null}
                        {ShowCol.Customer ? (
                          <td>{product?.buyerId?.firstname} {product?.buyerId?.lastname}</td>
                        ) : null}
                        {ShowCol.productname ? (
                          <td>{product?.productId?.productname}</td>
                        ) : null}

                        {ShowCol.paymentStatus ? (
                          <td>
                            {" "}
                            <span className="bg-custom-light py-1 px-3 rounded-pill">
                              {product?.payment_details?.status}
                            </span>
                          </td>
                        ) : null}

                        {/* <td>
          
                Paid
              </span>
            </td> */}
                        {ShowCol?.fulfilment_status ? (
                          <td>
                            {product?.deliveryStatusId?.deliveryStatus
                              ?.status == "Waiting on Seller" ? (
                              <Button className="order_status_waiting border text-white">
                                {
                                  product?.deliveryStatusId?.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : product?.deliveryStatusId?.deliveryStatus
                                ?.status == "Shipped From Seller" ? (
                              <Button className="order_status_shipped_seller border text-white">
                                {
                                  product?.deliveryStatusId?.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : product?.deliveryStatusId?.deliveryStatus
                                ?.status == "Ready For Test" ? (
                              <Button className="order_status_ready_test border text-white">
                                {
                                  product.deliveryStatusId.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : product?.deliveryStatusId?.deliveryStatus
                                ?.status == "Ready For Shipment" ? (
                              <Button className="order_status_ready_shipment border text-white">
                                {
                                  product?.deliveryStatusId?.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : product?.deliveryStatusId?.deliveryStatus
                                ?.status == "Shipped Out" ? (
                              <Button className="order_status_shipped_out border text-white">
                                {
                                  product.deliveryStatusId.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : product?.deliveryStatusId?.deliveryStatus
                                ?.status == "Recently Delivered" ? (
                              <Button className="order_status_recently_delivered border text-white">
                                {
                                  product.deliveryStatusId.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : product?.deliveryStatusId?.deliveryStatus
                                ?.status == "Return" ? (
                              <Button className="order_status_return border text-white">
                                {
                                  product.deliveryStatusId.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : product?.deliveryStatusId?.deliveryStatus
                                ?.status == "Return to Seller" ? (
                              <Button className="order_status_return border text-white">
                                {
                                  product?.deliveryStatusId?.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : product?.deliveryStatusId?.deliveryStatus
                                ?.status == "Refunded" ? (
                              <Button className="order_status_refunded border text-white">
                                {
                                  product?.deliveryStatusId?.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            ) : (
                              <Button className="order_status_return border text-white">
                                {
                                  product?.deliveryStatusId?.deliveryStatus
                                    ?.status
                                }
                              </Button>
                            )}
                          </td>
                        ) : null}
                      </tr>
                    ))
                  ) : (
                    <span>No Data Found</span>
                  )}
                </tbody>
              </Table>
            )}
          </div>
        </div>
      )}
      {FilterHedertext ? (
        ""
      ) : products1?.length > 0 ? (
        <Stack spacing={2}>
          {currenttab == "All" || currenttab == "" || currenttab == undefined 
          ?   
        <div 
        // className="pagination_box"
        style={{
          display: 'flex',          
          justifyContent: 'center', 
          alignItems: 'center',  
         marginBottom: '40px'
        }}
        >
            <ReactPaginate
              previousLabel={"< Previous"}
              nextLabel={"Next >"}
              breakLabel={"..."}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              pageCount={totalPageNumber}
              marginPagesDisplayed={paginationConfig.marginPagesDisplayed}
              pageRangeDisplayed={paginationConfig.pageRangeDisplayed}
              onPageChange={handlePageNumber}
              containerClassName={"pagination"}
              activeClassName={"active"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              forcePage={pageNumber - 1}
            />

        
          </div>
          
          :""}
         
        </Stack>
      ) : (
        ""
      )}

      <Modal
        className="custom_filter"
        show={smShow1}
        onHide={() => {
          setSmShow1(false);
        }}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton>Save as new view </Modal.Header>
        <Modal.Body className="scrollable-modal-body">
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>View name</Form.Label>
            <Form.Control
              type="text"
              onChange={(e) => {
                setTabnameTaxt(e.target.value);
              }}
            />
            <p>New views will be Saved as tabs at the top of this page</p>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setSmShow1(false);
            }}
            variant="danger"
          >
            Cancel{" "}
          </Button>
          {tabnameTaxt == null ? (
            <Button variant="success" disabled onClick={handleNewTab}>
              Save view
            </Button>
          ) : filterTabData ? (
            <Button variant="success" onClick={handleNewTab}>
              Save view
            </Button>
          ) : (
            <Button variant="success" disabled onClick={handleNewTab}>
              Save view
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        className="custom_filter"
        show={smShow}
        onHide={() => {
          // setFilterHedertext(text);
          setSmShow(false);
          setFilterOnCModal();
          setText();
        }}
      >
        <Modal.Header closeButton> Filter by</Modal.Header>
        <Modal.Body className="scrollable-modal-body">
          <Row>
            <Col className="mb-3 p-3">
              <Form.Select
                aria-label="Default select example"
                onChange={(e) => {
                  changeAddFilter(e.target.value);
                  // setFilterOnCModal(e.target.value);
                }}
              >
                <option value="">Select Filter </option>
                {/* <option value="order"> Order</option> */}
                <option value="Customer">Customer</option>
                <option value="Product Name">Product Name</option>
                <option value="FulFilment Status">FulFilment Status</option>
              </Form.Select>
            </Col>
            {FilterOnCModal ? (
              <Col className="mt-2" xs={4} xl={4}>
                <Dropdown style={{ marginBottom: "90px" }}>
                  <Dropdown.Toggle id="dropdown-basic">
                    {text ? text : "Select Value"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {FilterOnCModal == "Customer" ? (
                      <Form.Select
                        aria-label="Default select example"
                        onChange={(e) => {
                          setFilterTabData(e.target.value);
                          // HandleSearchData(e.target.value);
                          setFilterSearch(e.target.value);
                   
                        }}
                         
                        // style={{
                        //   maxHeight: '40px', // Adjust based on your needs
                        //   overflowY: 'auto',
                        // }}
                      >
                        <option value="">Select Customer</option>
                         
                         {allnames?.map((user, index) => (
                         <option  key={index} value={`${user?.firstname}`}>
                          {user?.firstname} {user?.lastname}
                          </option>
                           ))}
                      </Form.Select>
                    ) : FilterOnCModal == "Product Name" ? (
                      <Form.Select
                        aria-label="Default select example"
                        onChange={(e) => {
                          setFilterTabData(e.target.value);
                          // HandleSearchData(e.target.value);
                          setfilterstatus(true);

                          setFilterSearch(e.target.value);
                        }}
                      >
                        <option value="">Select Product Name </option>
                        {products1?.map((item) => {
                          return (
                            <option value={item?.productId?.productname}>
                              {item?.productId?.productname}
                            </option>
                          );
                        })}
                      </Form.Select>
                    ) : FilterOnCModal == "FulFilment Status" ? (
                      <Form.Select
                        aria-label="Default select example"
                        onChange={(e) => {
                          setFilterTabData(e.target.value);
                          // HandleSearchData(e.target.value);
                          setFilterSearch(e.target.value);
                        }}
                      >
                        <option value="">Select Status </option>
                        <option value="Waiting on Seller">
                          Waiting on Seller
                        </option>
                        <option value="Shipped From Seller">
                          Shipped From Seller
                        </option>
                        <option value="Ready For Test">Ready For Test</option>
                        <option value="Ready For Shipment">
                          Ready For Shipment
                        </option>
                        <option value="Shipped Out">Shipped Out</option>
                        <option value="Recently Delivered">
                          Recently Delivered
                        </option>
                        <option value="Return">Return</option>
                      </Form.Select>
                    ) : (
                      ""
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            ) : null}
            <Col></Col>
          </Row>
          <Modal.Footer className="border_bottom">
            <Button variant="danger" onClick={() => setSmShow(false)}>
              Close
            </Button>
            {FilterOnCModal && filterTabData ? (
              <Button
                variant="success"
                onClick={() => {
                  handleTableFilter();
                }}
              >
                Done
              </Button>
            ) : (
              <Button
                variant="success"
                onClick={() => {
                  handleTableFilter();
                }}
                disabled
              >
                Done
              </Button>
            )}
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </div>
  );
}
